// extracted by mini-css-extract-plugin
export default {"mainContainer":"App_mainContainer__vkggg","footer":"App_footer__FwuVS"};